import { useEffect, useState } from "react"

export default function useLocalstorage(key, initialValue) {
  const [value, setValue] = useState(() => {
    const storedJson = localStorage.getItem(key)
    if (storedJson !== null) return JSON.parse(storedJson)

    if (typeof initialValue === "function") {
      return initialValue()
    } else {
      return initialValue
    }
  })

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}
